export default __webpack_public_path__ + "static/media/icon-warning-fill.fc497956.svg";